import { createStyles, makeStyles } from '@mui/styles';

export const useIconStyles = makeStyles(() =>
  createStyles({
    flippedY: {
      transform: 'scaleY(-1)',
    },
  })
);
